import { configureStore } from "@reduxjs/toolkit";
import doulaSlice from "./doulaSlice";

const store = configureStore({
    reducer: {
        doula: doulaSlice.reducer,
    },
});

export default store;
